export default __webpack_public_path__ + "static/media/staff_detail_clock.16b32af3.svg";